import { userConstants } from '../constants';
import { userService } from '../service';
import _ from 'lodash';
var base64 = require('base-64');


export const validateUser = ({ phone }) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      userService.validateUser({ phone })
        .then(response => {
          let user = response;
          if (user.result === "success") {
            user.loginRequired = true;
          } else {
            user.otpRequired = true;
          }
          dispatch(sendOtp({ phone }))
          return resolve(user);
        },
          error => {
            return reject(error)
          })
    })
  }
}

export const sendOtp = ({ phone }) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      userService.sendOtp({ phone })
        .then(response => {
          return resolve(response);
        },
          error => {
            return reject(error)
          })
    })
  }
}

export const verifyOtp = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      userService.verifyOtp(data)
        .then(res => {
          if (res.data.token) {
            var user = {
              ...res.data.user
            }
            user.token = res.data.token.access
            localStorage.setItem('user', JSON.stringify(user))
            dispatch(fetchLoginSuccess({ user }));
            dispatch(getUserDetails(user.id))
              .then((logedinUser) => {
                return resolve(logedinUser);
              });
          }
          else {
            localStorage.setItem('user', JSON.stringify({ phone: data.phone }));
            dispatch(fetchLoginSuccess({ user: { phone: data.phone } }));
            return resolve(res.data);
          }
        },
          error => {
            return reject(error)
          })
    })
  }
}

export const fetchLoginSuccess = request => ({
  type: userConstants.LOGIN_SUCCESS,
  payload: request
})
export const fetchLoginFailure = request => ({
  type: userConstants.LOGIN_FAILURE,
  payload: request
})

export const login = (username, password, type) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.login({ username, password, role: type, type: type })
        .then(res => {
          var base64Url = res.access.split('.')[1];
          var decodedValue = JSON.parse(base64.decode(base64Url));
          decodedValue.id = decodedValue.user_id
          var user = {
            token: res.access,
            ...decodedValue
          }

          localStorage.setItem('user', JSON.stringify(user))
          dispatch(fetchLoginSuccess({ user }));
          dispatch(getUserDetails(user.id))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            dispatch(fetchLoginFailure({ user: {} }));
            return reject(error)
          })
    });
  }
}



export const getUserDetails = (id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.getUserDetails(id)
        .then(user => {
          let logedinUser = localStorage.getItem('user')
          logedinUser = JSON.parse(logedinUser)
          logedinUser = {
            ...logedinUser,
            ...user.data
          }
          localStorage.setItem('user', JSON.stringify(logedinUser))
          dispatch(fetchLoginSuccess({ user: logedinUser }));
          return resolve(logedinUser);
        },
          error => {
            return reject(error)
          })
    });
  }
}


export const uploadIdentityverification = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.uploadIdentityverification(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const saveResidentialAdress = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.saveResidentialAdress(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const uploadResidentialAdress = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.uploadResidentialAdress(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const saveFirmAdress = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.saveFirmAdress(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const uploadFirmAdress = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.uploadFirmAdress(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const saveBankDetailsAdress = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.saveBankDetailsAdress(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const uploadBankDetailsAdress = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.uploadBankDetailsAdress(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}


export const saveEducationalQualification = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.saveEducationalQualification(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}


export const uploadEducationalQualification = (userId, data, eduID) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.uploadEducationalQualification(data, eduID)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const deleteEducationalQualification = (userId, id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.deleteEducationalQualification(id)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}


export const saveExperience = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.saveExperience(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}


export const uploadExperience = (userId, data, eduID) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.uploadExperience(data, eduID)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const deleteExperience = (userId, id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.deleteExperience(id)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}


export const saveTraining = (userId, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.saveTraining(data)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}


export const uploadTraining = (userId, data, eduID) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.uploadTraining(data, eduID)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const deleteTraining = (userId, id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.deleteTraining(id)
        .then(res => {
          dispatch(getUserDetails(userId))
            .then((logedinUser) => {
              return resolve(logedinUser);
            });
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const getAllUsers = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.getAllUsers()
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const getUserDetailsByID = (id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.getUserDetailsByID(id)
        .then(user => {
          resolve(user);
        },
          error => {
            return reject(error)
          })
    });
  }
}

export const approveRejectUserDocument = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectUserDocument(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectIdentifyVerification = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectIdentifyVerification(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectResidentileDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectResidentileDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectFirmDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectFirmDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectEduAllDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectEduAllDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectExpAllDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectExpAllDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectTrainAllDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectTrainAllDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectVehicleAllDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectVehicleAllDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectExpDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectExpDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectEduDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectEduDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectTraDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectTraDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectBankDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectBankDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const userlogout = () => ({
  type: userConstants.LOGOUT,
  payload: { user: {} }
})


export const logout = () => {
  return dispatch => {
    userService.logout();
    return dispatch(userlogout());
  }
}


export const downloadReportDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.downloadReportDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const downloadResolutionDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.downloadResolutionDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const downloadreferralDetail = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.downloadreferralDetail(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const getResolutionData = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.getResolutionData()
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const downloadUserData = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.downloadUserData(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const approveRejectBusiness = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.approveRejectBusiness(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const getReferralData = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.getReferralData()
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}

export const updateReferralData = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      return userService.updareReferralData(data)
      .then(response => {
        resolve(response);
      },
      error => {
        return reject(error)
      })
    });
  }
}